import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
import { has } from 'lodash'

import CompactUniqueSellingPoint from 'components/uniqueSellingPoint/CompactUniqueSellingPoint'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

export interface RTFContentfulUniqueSellingPointGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulUniqueSellingPoint
  title: string
  description: EF.RTFRawQueryResponse
  icon: {
    fields: {
      asset: {
        file: {
          url: string
        }
      }
    }
  }
}

export interface ContentfulUniqueSellingPointBlockProps
  extends RTFBlockComponentProps {
  title: string
  description: EF.RTFRawQueryResponse
  icon: {
    fields: {
      asset: {
        file: {
          url: string
        }
      }
    }
  }
}

const ContentfulUniqueSellingPointBlock: FunctionComponent<ContentfulUniqueSellingPointBlockProps> = ({
  title,
  description,
  icon,
}) => {
  return (
    <CompactUniqueSellingPoint
      title={title}
      icon={icon.fields.asset}
      description={description}
    />
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulUniqueSellingPointBlock,
  isValid: ({ title, description, icon }) =>
    !!title && has(description, 'raw') && has(icon, 'fields.asset.file.url'),
}

export default componentExport
